import React from "react";
import Routing from "./Routes/Routing";

// Store and providers
import { Provider } from "react-redux";
import { MapProvider } from "./contexts/ClustererContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import store from "./Redux/store";

import { registerLicense } from "@syncfusion/ej2-base";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Styles
import { SelectedProvider } from "./contexts/SelectedContext";
import "./styles/themes.css";

registerLicense(process.env.REACT_APP_SYNCFUSION_SECRET);
registerFirebase();

function registerFirebase() {
  const app = initializeApp({
    apiKey: "AIzaSyBGr3Nva_5ILXjWopLjd_K7VmcVA8o6FPU",
    authDomain: "movyx-maps.firebaseapp.com",
    projectId: "movyx-maps",
    storageBucket: "movyx-maps.firebasestorage.app",
    messagingSenderId: "859852506246",
    appId: "1:859852506246:web:6e77f461366d479e3b3d07",
    measurementId: "G-Z0J2289W35",
  });
  const fcm = getMessaging(app);
  console.log(
    getToken(fcm, { vapidKey: process.env.REACT_APP_FCM_VAPID_KEY })
      .then((currentToken) => {
        if (currentToken) {
          console.log("current token for client: ", currentToken);
        }
      })
      .catch((err) => {
        console.log("An error occurred while retrieving token. ", err);
      })
  );

  Notification.requestPermission().then((permission) => {
    if (permission === "granted") {
      console.log("Notification permission granted.");
    } else {
      console.log("Unable to get permission to notify.");
    }
  });

  onMessage(fcm, (payload) => {
    console.log("Message received. ", payload);
    const { title, body } = payload.notification;
    alert(title + " " + body);
  });
}

function App() {
  return (
    <React.Fragment>
      <Provider store={store}>
        <ThemeProvider>
          <SelectedProvider>
            <MapProvider>
              <Routing />
            </MapProvider>
          </SelectedProvider>
        </ThemeProvider>
      </Provider>
    </React.Fragment>
  );
}

export default App;
